import { graphql } from 'react-relay';
export const waitForEditionChangeQuery = graphql`
	query waitForEditionChangeQuery {
		tenant: confluence_tenantContext {
			editions {
				confluence
			}
		}
	}
`;
